import {Box, Skeleton, Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

import {BackwardTitleTemplate} from '@/components/molecules/BackwardTitleTemplate';

const ProfileSkeleton = () => (
  <Box
    sx={{
      backgroundColor: 'transparent',
      borderRadius: 2,
      margin: 'auto',
      color: '#fff',
    }}>
    <Grid px={2} mt={1} size={12}>
      <BackwardTitleTemplate isShowHrefBtn={false} />
    </Grid>
    <Grid px={2} mt={1} size={12}>
      <Grid
        size={12}
        display={'flex'}
        p={'12px'}
        sx={{
          backgroundColor: 'background.default',
          borderRadius: '12px',
        }}
        alignItems={'center'}
        justifyContent={'space-between'}>
        <Grid size={12} container alignItems={'center'} spacing={1}>
          <Grid
            size="auto"
            sx={{
              height: '42px',
            }}>
            <Skeleton
              variant="rectangular"
              width={45}
              height={45}
              sx={{
                borderRadius: '0.75rem',
              }}
            />
          </Grid>
          <Grid
            size={'grow'}
            display={'flex'}
            flexDirection={'column'}
            container>
            <Skeleton variant="rectangular" width="80px" height={'0.75rem'} />
            <Grid size={12} gap={'4px'} display={'flex'} alignItems={'center'}>
              <Skeleton variant="rectangular" width="20px" height={'1rem'} />
              <Skeleton variant="rectangular" width="100px" height={'1rem'} />
            </Grid>
          </Grid>
        </Grid>
        <Grid mr={1}>
          <Skeleton variant="rectangular" width="60px" height={'1rem'} />
        </Grid>
      </Grid>
      <Grid
        size={12}
        mt={2}
        display={'flex'}
        p={'12px'}
        sx={{
          backgroundColor: 'background.default',
          borderRadius: '12px',
        }}
        flexDirection={'column'}>
        <Grid>
          <Skeleton variant="rectangular" width="100px" height={'0.7rem'} />
        </Grid>
        <Grid
          size={12}
          display={'flex'}
          alignItems={'center'}
          mt={2}
          justifyContent={'space-between'}>
          {[0, 1, 2, 3].map(item => (
            <Grid key={item}>
              <Skeleton variant="circular" width="64px" height="64px" />
              <Typography
                fontSize="1.125rem"
                width="100%"
                lineHeight="1.54rem"
                mt="0.1rem"
                fontFamily="Alfa Slab One">
                <Skeleton width="100%" />
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
    <Grid size={12} p={2} mt={1}>
      <Skeleton variant="rectangular" sx={{borderRadius: '12px'}} height={76} />
    </Grid>

    <Grid size={12} py={2} px={3}>
      <Stack spacing={2} width={'100%'}>
        {[0, 1, 2, 3, 4, 5, 6].map(item => (
          <Grid
            key={item}
            display={'flex'}
            alignItems={'center'}
            sx={{pb: 2}}
            justifyContent={'space-between'}>
            <Grid display={'flex'} alignItems={'center'}>
              <Skeleton variant="rectangular" height={18} width={18} />
              <Skeleton
                variant="rectangular"
                height={18}
                width={90}
                sx={{ml: '10px'}}
              />
            </Grid>
            <Grid>
              <Skeleton variant="rectangular" height={18} width={18} />
            </Grid>
          </Grid>
        ))}
      </Stack>
    </Grid>
  </Box>
);

export default ProfileSkeleton;
